import React from "react";
import PropTypes from "prop-types";
import { FluentInput } from "../../../../../components/FluentUI/Fluent-Input";
import { FluentInputArea } from "../../../../../components/FluentUI/Fluent-InputArea";
import { FluentRadio } from "../../../../../components/FluentUI/Fluent-Radio";
import { FluentField } from "../../../../../components/FluentUI/Fluent-Field";
import "./template-creation.scss";

const TemplateCreationFormLeftNew = ({
  values,
  errors,
  handleChange,
  handleBlur,
  touched,
  isView,
  setFieldValue,
}) => {
  return (
    <div className="left-row">
      <div className="left-header">
        <FluentField label="General Settings" size="large" />
      </div>
      <div className="template-name">
        <FluentInput
          id="ProjectType"
          name="ProjectType"
          label="Project Template Name"
          placeholder="Enter Project Template Name"
          value={values?.ProjectType || ""}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          validationMessage={
            touched.ProjectType && errors.ProjectType
              ? errors.ProjectType
              : undefined
          }
          componentStyle="w-full"
          noKey
        />
      </div>

      <div className="description">
        <FluentInputArea
          id="Description"
          name="Description"
          label="Description"
          placeholder="Enter Description"
          value={values?.Description || ""}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={isView}
          validationMessage={
            touched.Description && errors.Description
              ? errors.Description
              : undefined
          }
          componentStyle="textarea"
          size="medium"
          noKey
        />
      </div>

      <div className="access-to-template">
        <FluentRadio
          label={<span className="left-align-label">Access to Template</span>}
          name="IsVisible"
          layout="horizontal"
          disabled={isView}
          value={values?.IsVisible ? "public" : "private"}
          options={[
            { label: "Public", value: "public" },
            { label: "Private", value: "private" },
          ]}
          onChange={(_, data) =>
            setFieldValue("IsVisible", data.value === "public")
          }
          validationMessage={
            touched.IsVisible && errors.IsVisible ? errors.IsVisible : undefined
          }
        />
      </div>
    </div>
  );
};

TemplateCreationFormLeftNew.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  values: PropTypes.object,
  touched: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  isView: PropTypes.bool.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

export default TemplateCreationFormLeftNew;